import React from 'react';

const icons = {
  clock: (
    <>
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 7.8v4.8l3.2 2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  location: (
    <>
      <path d="M12 21s-6-5.5-6-11a6 6 0 1 1 12 0c0 5.5-6 11-6 11Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <circle cx="12" cy="10" r="2.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
    </>
  ),
  car: (
    <>
      <path d="M5 15.5 6.8 10h10.4L19 15.5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="4" y="12.5" width="16" height="5" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="7.5" cy="18" r="1.5" fill="currentColor" />
      <circle cx="16.5" cy="18" r="1.5" fill="currentColor" />
    </>
  ),
  phone: (
    <>
      <path d="M8 4h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="17" r="1" fill="currentColor" />
    </>
  ),
  temple: (
    <>
      <path d="M12 4 5 8.2v1.3h14V8.2L12 4Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M7.5 9.5V18M12 9.5V18M16.5 9.5V18M5 18h14M9.5 20h5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  lamp: (
    <>
      <path d="M12 4.5c1.2 1.2 1.8 2.3 1.8 3.4A1.8 1.8 0 0 1 12 9.7a1.8 1.8 0 0 1-1.8-1.8c0-1.1.6-2.2 1.8-3.4Z" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M6 14.5h12l-1.6 3.5H7.6L6 14.5ZM10 18v2m4-2v2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  prayer: (
    <>
      <path d="M10.3 6.2 8 10l1 7m4-10.8L15.8 10l-1 7M9 11.5h6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.5 18h9" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  festival: (
    <>
      <path d="M12 4v16M6 9.5h12M8 6.5l2 3m6-3-2 3M8 17.5l2-3m6 3-2-3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="1.8" fill="currentColor" />
    </>
  ),
  restroom: (
    <>
      <circle cx="9" cy="6" r="1.6" fill="currentColor" />
      <circle cx="15" cy="6" r="1.6" fill="currentColor" />
      <path d="M9 8.5v5.5M7 20l2-6 2 6M15 8.5V20M13.2 12h3.6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  water: (
    <>
      <path d="M12 4.5C9.2 8 7.8 10.5 7.8 13a4.2 4.2 0 1 0 8.4 0c0-2.5-1.4-5-4.2-8.5Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
    </>
  ),
  food: (
    <>
      <path d="M6.5 5.5v6M8.5 5.5v6M7.5 11.5V20M14.5 5.5v8c0 1.3 1 2.3 2.3 2.3H18V20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  accessibility: (
    <>
      <circle cx="12" cy="5.7" r="1.6" fill="currentColor" />
      <path d="M12 8.5v4m0 0 4.2 1m-4.2-1-3 3.8m3-3.8-1.6 7.2m1.6-7.2 3.6 6.3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  bag: (
    <>
      <path d="M7 9V7a5 5 0 0 1 10 0v2M6 9h12l-1 10H7L6 9Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  road: (
    <>
      <path d="M9 4 7 20m8-16 2 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M12 6.5v2.5m0 3v2.5m0 3v2.5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  bus: (
    <>
      <rect x="5" y="4.5" width="14" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M5 9.5h14M8 16.5V19M16 16.5V19" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="8.5" cy="13.5" r="1.2" fill="currentColor" />
      <circle cx="15.5" cy="13.5" r="1.2" fill="currentColor" />
    </>
  ),
  pin: (
    <>
      <path d="M12 20V12M8 8l4-4 4 4M9 12h6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  train: (
    <>
      <rect x="7" y="4.5" width="10" height="11" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M9.5 8h5M10 15.5l-2 4m6-4 2 4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="10" cy="12" r="1" fill="currentColor" />
      <circle cx="14" cy="12" r="1" fill="currentColor" />
    </>
  ),
  map: (
    <>
      <path d="M4.5 6.5 9 4l6 2.5 4.5-2V18L15 20.5 9 18 4.5 20V6.5Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <path d="M9 4v14M15 6.5v14" fill="none" stroke="currentColor" strokeWidth="1.8" />
    </>
  ),
  landscape: (
    <>
      <path d="M4 18 9 11l3 4 3-3 5 6H4Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      <circle cx="8" cy="8" r="1.8" fill="currentColor" />
    </>
  ),
  flag: (
    <>
      <path d="M7 20V4m0 1h9l-2 3 2 3H7" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  handshake: (
    <>
      <path d="M8.5 12.5 6 10l2.5-2.5a2.8 2.8 0 0 1 4 0L14 9m1.5 3.5L18 10l-2.5-2.5a2.8 2.8 0 0 0-4 0L10 9" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="m9.5 12.5 1.2 1.2m1.1-1.1 1.2 1.2m1.1-1.1 1.2 1.2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  om: (
    <>
      <path d="M10.2 9.5a2.7 2.7 0 1 1 2.3 4.8 3 3 0 1 1-2.8 4.2M12.8 8.2c1.2-1.7 4-.9 4 .9 0 1.2-1 2.1-2.4 2.1h-1.1m2.7-4.8v-2m0 0 .9.9m-.9-.9-.9.9m3.2 2.7h1.8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  trident: (
    <>
      <path d="M12 4v16M8 7c0 2 1.1 4 4 4s4-2 4-4M8 7V5m8 2V5m-4 15-2 2m2-2 2 2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  flower: (
    <>
      <circle cx="12" cy="12" r="1.8" fill="currentColor" />
      <path d="M12 6.2c1.7-2 4.5-.8 4.5 1.3 0 1.3-.9 2.3-2.3 2.5M17.8 12c2 1.7.8 4.5-1.3 4.5-1.3 0-2.3-.9-2.5-2.3M12 17.8c-1.7 2-4.5.8-4.5-1.3 0-1.3.9-2.3 2.3-2.5M6.2 12c-2-1.7-.8-4.5 1.3-4.5 1.3 0 2.3.9 2.5 2.3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  elephant: (
    <>
      <path d="M7 16V9a4 4 0 0 1 4-4h2.5A3.5 3.5 0 0 1 17 8.5v2.7a2.8 2.8 0 0 1-2.8 2.8H13V17m-4 0v2m8-2v2M17 10.5h1.5a1.5 1.5 0 0 1 0 3H17m-6.5-2.5h1" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  user: (
    <>
      <circle cx="12" cy="9" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M6 19a6 6 0 0 1 12 0" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  scan: (
    <>
      <path d="M7 4H5a1 1 0 0 0-1 1v2m13-3h2a1 1 0 0 1 1 1v2M7 20H5a1 1 0 0 1-1-1v-2m13 3h2a1 1 0 0 0 1-1v-2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M8 9h8M8 12h8M8 15h5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  utensils: (
    <>
      <path d="M7 4.5v6M9 4.5v6M8 10.5V20M15 4.5v8c0 1.1.9 2 2 2h0V20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  cow: (
    <>
      <path d="M6 10.5 7.8 8h8.4L18 10.5V17h-2v-2H8v2H6v-6.5ZM8.2 8l-1-2m8.6 2 1-2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="9.5" cy="12" r="1" fill="currentColor" />
      <circle cx="14.5" cy="12" r="1" fill="currentColor" />
    </>
  ),
  mail: (
    <>
      <rect x="4" y="6" width="16" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="m5.5 7.5 6.5 5 6.5-5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  certificate: (
    <>
      <rect x="4" y="4" width="16" height="13" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8 9h8M8 12.5h5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M12 17v3m-2-1.5 2 1.5 2-1.5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  check: (
    <>
      <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="m8.8 12 2.4 2.4 4-4.8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  calendar: (
    <>
      <rect x="4.5" y="5.5" width="15" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M8.5 4v3M15.5 4v3M4.5 10.5h15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="9" cy="14.5" r="1" fill="currentColor" />
      <circle cx="12" cy="14.5" r="1" fill="currentColor" />
      <circle cx="15" cy="14.5" r="1" fill="currentColor" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 11v5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <circle cx="12" cy="8.2" r="1" fill="currentColor" />
    </>
  ),
};

const Icon = ({ name, className = '', title }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden={title ? undefined : 'true'}
    role={title ? 'img' : 'presentation'}
  >
    {title ? <title>{title}</title> : null}
    {icons[name] || icons.temple}
  </svg>
);

export default Icon;
